/* assets/src/viewer/env/sky.js
 * Ambiente asset-free: Sky-shader (three/addons) come cielo visibile +
 * PMREMGenerator.fromScene per IBL/riflessi credibili. Nessun file HDRI obbligatorio.
 * Il sole è condiviso con la DirectionalLight (vedi lighting.js).
 */
import * as THREE from 'three';
import { Sky } from 'three/addons/objects/Sky.js';

export class SkyEnvironment {
  constructor(renderer, scene) {
    this.renderer = renderer;
    this.scene = scene;

    this.sky = new Sky();
    this.sky.scale.setScalar(45000);
    const u = this.sky.material.uniforms;
    u.turbidity.value = 3.2;
    u.rayleigh.value = 2.6;
    u.mieCoefficient.value = 0.005;
    u.mieDirectionalG.value = 0.82;

    this.sunDir = new THREE.Vector3(0.4, 0.6, 0.3).normalize();
    this.sky.material.uniforms.sunPosition.value.copy(this.sunDir);
    scene.add(this.sky);

    this.pmrem = new THREE.PMREMGenerator(renderer);
    if (this.pmrem.compileEquirectangularShader) this.pmrem.compileEquirectangularShader();
    this._envScene = new THREE.Scene();
    this._renderTarget = null;
  }

  // Imposta la direzione del sole (vettore già in coordinate mondo).
  setSunDirection(vec) {
    this.sunDir.copy(vec).normalize();
    this.sky.material.uniforms.sunPosition.value.copy(this.sunDir);
  }

  // Atmosfera notte/giorno: di notte il cielo si spegne (turbidity/rayleigh bassi).
  setNight(isNight) {
    const u = this.sky.material.uniforms;
    if (isNight) {
      u.turbidity.value = 0.8;
      u.rayleigh.value = 0.25;
      u.mieCoefficient.value = 0.002;
    } else {
      u.turbidity.value = 3.2;
      u.rayleigh.value = 2.6;
      u.mieCoefficient.value = 0.005;
    }
  }

  // Rigenera la env-map dal cielo corrente (costoso: chiamare on-commit, non per-frame).
  updateEnvironment() {
    if (this._renderTarget) this._renderTarget.dispose();
    this._envScene.add(this.sky);
    this._renderTarget = this.pmrem.fromScene(this._envScene);
    this.scene.add(this.sky); // riporta il dome nella scena principale (resta sfondo)
    this.scene.environment = this._renderTarget.texture;
    return this._renderTarget.texture;
  }

  dispose() {
    if (this._renderTarget) this._renderTarget.dispose();
    this.pmrem.dispose();
    if (this.sky.material) this.sky.material.dispose();
    if (this.sky.geometry) this.sky.geometry.dispose();
  }
}
